import { ContentHeader } from '../../components/layout/ContentHeader'
import { ComingSoon } from '../../components/ui/ComingSoon'
import { useParams } from 'react-router-dom'

export default function AuditChecklist() {
  const { projectId } = useParams<{ projectId: string }>()
  return (
    <>
      <ContentHeader breadcrumb={[{ label: 'Audit de site Web', to: `/p/${projectId}/audit` }, { label: 'Checklist SEO' }]} title="Checklist SEO" />
      <ComingSoon title="Checklist SEO" description="La checklist complete avec plus de 100 verifications SEO categorisees arrive bientot." />
    </>
  )
}
